<div class="card-head">
  <h2>Merchant data</h2>
  <div class="flex-fill"></div>
  <span class="format-tag" matTooltip="Free-text field submitted by the merchant with the payment"
        data-test="tx-detail-merchant-data-format">{{ formatLabel }}</span>
</div>

<div class="card-body">
  @if (format === 'text') {
    <p class="md-text" data-test="paymentDetail">{{ displayText }}</p>
  } @else {
    <div data-test="paymentDetail">
      @for (pair of pairs; track pair.key) {
        <div class="kv-row">
          <span class="kv-k">{{ pair.key }}</span>
          <span class="kv-v">
            @if (pair.nested) {
              <span class="md-nested">{{ pair.value }}</span>
            } @else {
              {{ pair.value }}
            }
          </span>
        </div>
      }
    </div>

    <details class="rawjson">
      <summary>As submitted</summary>
      <pre>{{ value }}</pre>
    </details>
  }
</div>
